import { Badge, CustomerRoleTypeBadge, VSpacer } from '@/components/DesignSystem';
import Mail from '@mui/icons-material/Mail';
import { Divider, Stack } from '@mui/material';
import { DemoBlock } from '../../components/DemoBlock';
import { AccountGroupRole } from '@shared/enums';

export const BadgeDemo = () => {
  return (
    <>
      <DemoBlock label="Corner Badges">
        <Stack
          alignItems="top"
          direction="row"
          divider={<Divider flexItem orientation="vertical" />}
          spacing={2}
        >
          <Stack alignItems="center" spacing={4}>
            Primary
            <VSpacer size="3" />
            <Badge color="primary" content={1} testID="badge-demo-primary"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Secondary
            <VSpacer size="3" />
            <Badge color="secondary" content={1} testID="badge-demo-secondary"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Error
            <VSpacer size="3" />
            <Badge color="error" content={1} testID="badge-demo-error"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Info
            <VSpacer size="3" />
            <Badge color="info" content={1} testID="badge-demo-info"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Warning
            <VSpacer size="3" />
            <Badge color="warning" content={1} testID="badge-demo-warning"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Default
            <VSpacer size="3" />
            <Badge color="default" content={1} testID="badge-demo-default"><Mail /></Badge>
          </Stack>
          <Stack alignItems="center" spacing={4}>
            Success
            <VSpacer size="3" />
            <Badge color="success" content={1} testID="badge-demo-success"><Mail /></Badge>
          </Stack>
        </Stack>
      </DemoBlock>
      <VSpacer size="8" />
      <DemoBlock label="Personal Indicator Badges">
        <Stack direction="row" spacing={4}>
          <CustomerRoleTypeBadge
            accountGroupRole={AccountGroupRole.Primary}
            testID="badge-demo-shared"
          />
          <CustomerRoleTypeBadge
            accountGroupRole={AccountGroupRole.IndependentPartner}
            testID="badge-demo-personal"
          />
        </Stack>
      </DemoBlock>
    </>
  );
};
